import React from 'react'

function SidemenuCloseBtn({setOpen}) {

    // ** function to handle side menu close
    const openSideMenu = () => {
        setOpen(false) 
    }

    return (
        <div className='closeBtnCon'>
            <button type='button' className='btn' onClick={openSideMenu}>
                <i className="fas fa-times"></i>
            </button>
        </div>
        
    )
}

export default SidemenuCloseBtn